import { render, staticRenderFns } from "./quartercard_one.vue?vue&type=template&id=6e2bd8fd&scoped=true&"
import script from "./quartercard_one.vue?vue&type=script&lang=js&"
export * from "./quartercard_one.vue?vue&type=script&lang=js&"
import style0 from "./quartercard_one.vue?vue&type=style&index=0&id=6e2bd8fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2bd8fd",
  null
  
)

export default component.exports